<template>
	<div>
		<div class="flex justify-between px-0 py-s10 border-b border-light-gray mt-s5 m_800:px-s20">
			<p>Ukupno:</p>
			<p>{{ formatPrice(getSubtotalPrice) }} RSD</p>
		</div>
		<div class="flex justify-between px-0 py-s10 border-b border-light-gray mt-s5 m_800:px-s20">
			<p>Popust:</p>
			<p>{{ formatPrice(getSubtotalPrice - getTotalPrice)}} RSD</p>
		</div>
		<div class="flex justify-between px-0 py-s10 border-b border-light-gray mt-s5 m_800:px-s20 font-medium">
			<p>Ukupno za naplatu:</p>
			<p>{{ formatPrice(getTotalPrice) }} RSD</p>
		</div>

	</div>
</template>

<script>
import accounting from "accounting";

export default {
	name: "CheckoutPricesTable",

	computed: {


		/**
		 * Retrieve cart items total price from vuex store
		 */
		getTotalPrice() {
			return this.$store.getters['Cart/getTotalPrice'];
		},

		/**
		 * Retrieve cart items subtotal price from vuex store
		 */
		getSubtotalPrice() {
			return this.$store.getters['Cart/getSubtotalPrice'];
		},

	},

	methods: {

		/**
		 * Format price.
		 *
		 * @param value
		 */
		formatPrice(value) {

			return accounting.formatMoney(value, '', 2, '.', ',')
		},
	}

}
</script>
